class FeaturesSplitVideo {
  constructor(element) {
    this.element = element;
    this.preview = this.element.querySelector('[data-element="preview"]');
    this.button = this.element.querySelector('[data-element="button"]');
    this.player = this.element.querySelector('[data-element="player"]');
    this.playerType = this.player.dataset.type;
    this.vimeoPlayer = null;
    this.vimeoVideo = null;
    this.youtubePlayer = null;
    this.youtubeVideo = null;
  }

  init() {
    if ('vimeo' === this.playerType) {
      this.loadVimeoApi();
      this.setupVimeoApi();
    } else if ('youtube' === this.playerType) {
      this.loadYoutubeApi();
      this.setupYoutubeApi();
    }

    this.button.addEventListener('click', this.buttonOnClick.bind(this));
  }

  loadVimeoApi() {
    this.vimeoVideo = this.element.querySelector('[data-element="vimeo"]');
    const id = 'features-split-video-vimeo-api';
    const apiScript = document.getElementById(id);

    if ( null !== apiScript ) {
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    tag.id = id;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  setupVimeoApi() {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      this.vimeoPlayer = new Vimeo.Player(this.vimeoVideo.id, {
        id: this.vimeoVideo.dataset.id,
      });
    }, 500);
  }

  playVimeo() {
    this.vimeoPlayer.play();
  }

  loadYoutubeApi() {
    this.youtubeVideo = this.element.querySelector('[data-element="youtube"]');
    const id = 'features-split-video-youtube-api';
    const apiScript = document.getElementById(id);

    if ( null !== apiScript ) {
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.id = id;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  setupYoutubeApi() {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      this.youtubePlayer = new YT.Player(this.youtubeVideo.id, {
        videoId: this.youtubeVideo.dataset.id,
      });
    }, 500);
  }

  playYoutube() {
    this.youtubePlayer.playVideo();
  }

  buttonOnClick() {
    this.preview.classList.add('features-split-video__preview--hide');
    this.player.classList.add('features-split-video__player--show');

    if ('vimeo' === this.playerType) {
      this.playVimeo();
    } else if ('youtube' === this.playerType) {
      this.playYoutube();
    }
  }
}

const featuresSplitVideo = {
  init() {
    const featuresSplitVideoElements = document.querySelectorAll('[data-module="features-split-video"]');

    if (featuresSplitVideoElements && featuresSplitVideoElements.length) {
      featuresSplitVideoElements.forEach((element) => {
        const featuresSplitVideoElement = new FeaturesSplitVideo(element);
        featuresSplitVideoElement.init();
      });
    }
  },
};

export default featuresSplitVideo;
